module.exports = __webpack_public_path__ + "img/dd.41afb6ba.png";